/**
 * @generated SignedSource<<e71d0855c0d014bbe572a79ff4bfe048>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
export type SettingsBillingAdminQuery$variables = {
  id: string;
};
export type SettingsBillingAdminQuery$data = {
  readonly workspace: {
    readonly userWorkspacePermissions: {
      readonly admin: boolean;
    } | null;
  } | null;
};
export type SettingsBillingAdminQuery = {
  response: SettingsBillingAdminQuery$data;
  variables: SettingsBillingAdminQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "concreteType": "UserWorkspacePermissions",
  "kind": "LinkedField",
  "name": "userWorkspacePermissions",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "admin"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SettingsBillingAdminQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsBillingAdminQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0d5014a7006238032666adc00c5fc810",
    "id": null,
    "metadata": {},
    "name": "SettingsBillingAdminQuery",
    "operationKind": "query",
    "text": "query SettingsBillingAdminQuery(\n  $id: ID!\n) {\n  workspace(id: $id) {\n    userWorkspacePermissions {\n      admin\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "24afb23f8a8b8600003794624bdc2cf4";

export default node;
